/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Result_TermInputs */

const en_how_we_work_brief_result_term = /** @type {(inputs: How_We_Work_Brief_Result_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useful result`)
};

const lv_how_we_work_brief_result_term = /** @type {(inputs: How_We_Work_Brief_Result_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noderīgs rezultāts`)
};

/**
* | output |
* | --- |
* | "Useful result" |
*
* @param {How_We_Work_Brief_Result_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_result_term = /** @type {((inputs?: How_We_Work_Brief_Result_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Result_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_result_term(inputs)
	return en_how_we_work_brief_result_term(inputs)
});